import { useSyncExternalStore } from "react";

/** 画面の一覧。server は /api 以外のパスに index.html を返すので、どのパスでも直接開ける */
export const ROUTES = {
  products: "/",
  profile: "/profile",
  security: "/security",
  loginHistory: "/login-history",
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

const KNOWN_PATHS = new Set<string>(Object.values(ROUTES));

function subscribe(onChange: () => void) {
  window.addEventListener("popstate", onChange);
  return () => window.removeEventListener("popstate", onChange);
}

function currentPath(): RoutePath {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  return KNOWN_PATHS.has(path) ? (path as RoutePath) : ROUTES.products;
}

export function usePath(): RoutePath {
  return useSyncExternalStore(subscribe, currentPath);
}

export function navigate(path: RoutePath) {
  if (window.location.pathname === path) return;
  window.history.pushState(null, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
  window.scrollTo?.(0, 0);
}
